import { BrowserStorage } from '@atc/browser-storage';

/**
 * @typedef {Object} cacheSubObject
 * @property {String} rootKey
 * @property {String} key
 */

/**
 * Handles storing and caching sub-objects of cache
 * @module SubObjectCache
 */

export default class SubObjectCache {
  constructor(options) {
    if (options === void 0) {
      options = {};
    }
    const {
      persist = true
    } = options;
    this.storage = new BrowserStorage(options.rootKey, {
      persist
    });
    this.options = {
      key: options.key || '',
      expiration: options.expiration
    };
  }

  /**
   * Check for expired item
   * @alias module:SubObjectCache
   * @param {Object}
   * @return {Object}
   */
  checkExpired(item) {
    if (item === void 0) {
      item = {};
    }
    const now = new Date().getTime();
    const age = now - item.timeStamp;
    return age > this.options.expiration ? {} : item;
  }

  /**
   * @alias module:SubObjectCache
   * @return {Object}
   */
  getItem() {
    const cache = this.storage.getItem() || {};
    const item = cache[this.options.key] || {};
    return this.options.expiration ? this.checkExpired(cache[this.options.key]) : item;
  }

  /**
   * Replace current cached sub-object with a new item
   * @alias module:SubObjectCache
   * @param {Object}
   * @return {this}
   */
  setItem(item) {
    if (item === void 0) {
      item = {};
    }
    const cache = this.storage.getItem();
    const obj = {};
    if (this.options.expiration) {
      item.timeStamp = new Date().getTime();
    }
    obj[this.options.key] = item;
    this.storage.setItem({
      ...cache,
      ...obj
    });
    return this;
  }

  /**
   * @alias module:SubObjectCache
   * @return {this}
   */
  clearItem() {
    const cache = this.storage.getItem();
    delete cache[this.options.key];
    this.storage.setItem(this.cache);
    return this;
  }
}